<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="toc"><a href="#/Acknowledgements#Ack">Acknowledgements</a></p>
<p class="toc1"><a href="#/Chapter1#C1">1. Debut of a Killer</a></p>
<p class="toc"><a href="#/Chapter2#C2">2. Arrival of the Police</a></p>
<p class="toc"><a href="#/Chapter3#C3">3. The Investigation Begins</a></p>
<p class="toc"><span href="#/Chapter4#C4" title="Link target outside of Sample">4. Life Goes On</span></p>
<p class="toc"><span href="#/Chapter5#C5" title="Link target outside of Sample">5. A Killer Returns</span></p>
<p class="toc"><span href="#/Chapter6#C6" title="Link target outside of Sample">6. The New Sheriff</span></p>
<p class="toc"><span href="#/Chapter7#C7" title="Link target outside of Sample">7. Aftermath of the Second Shooting</span></p>
<p class="toc"><span href="#/Chapter8#C8" title="Link target outside of Sample">8. Third Time’s a Charm</span></p>
<p class="toc"><span href="#/Chapter9#C9" title="Link target outside of Sample">9. Interrogations Begin Again</span></p>
<p class="toc"><span href="#/Chapter10#C10" title="Link target outside of Sample">10. News Conference</span></p>
<p class="toc"><span href="#/Chapter11#C11" title="Link target outside of Sample">11. A Big Reward Is Offered</span></p>
<p class="toc"><span href="#/Chapter12#C12" title="Link target outside of Sample">12. Prosecutor Hooper Makes a Discovery</span></p>
<p class="toc"><span href="#/Chapter13#C13" title="Link target outside of Sample">13. Reporters Want the Scoop</span></p>
<p class="toc"><span href="#/Chapter14#C14" title="Link target outside of Sample">14. Captured</span></p>
<p class="toc"><span href="#/Chapter15#C15" title="Link target outside of Sample">15. Arraignment and Indictment</span></p>
<p class="toc"><span href="#/Chapter16#C16" title="Link target outside of Sample">16. The Grand Jury</span></p>
<p class="toc"><span href="#/Chapter17#C17" title="Link target outside of Sample">17. Law Enforcement Stays Busy</span></p>
<p class="toc"><span href="#/Chapter18#C18" title="Link target outside of Sample">18. Public Enemy No. 1 Spotted in Jefferson County, Ohio</span></p>
<p class="toc"><span href="#/Chapter19#C19" title="Link target outside of Sample">19. The Trial</span></p>
<p class="toc"><span href="#/Chapter20#C20" title="Link target outside of Sample">20. The Phantom Testifies</span></p>
<p class="toc"><span href="#/Chapter21#C21" title="Link target outside of Sample">21. The Verdict</span></p>
<p class="toc"><span href="#/Chapter22#C22" title="Link target outside of Sample">22. Reward Claims Pour In</span></p>
<p class="toc"><span href="#/Chapter23#C23" title="Link target outside of Sample">23. Those Left Behind</span></p>
<p class="toc"><span href="#/Chapter24#C24" title="Link target outside of Sample">24. The Sheriffs of Jefferson County, Ohio</span></p>
<p class="toc1"><span href="#/Bibliography#Bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/Author#Aut" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?168da766